export function createReleaseSettlementWorker() {
  return new Worker(new URL('./releaseSettling.worker.js', import.meta.url));
}
